import * as React from "react";

import { LineID } from "../api/APIClient";
import LinePickerContainer from "./LinePicker";

interface IProps {
  lines?: LineID[];
  onChange: (value: LineID[]) => any;
}

interface IState {
  inputRef: HTMLInputElement | null;
  pickerOpen: boolean;
}

export class LineIDInput extends React.Component<IProps, IState> {
  public state: IState = {
    inputRef: null,
    pickerOpen: false,
  };

  public render() {
    const { lines } = this.props;
    const { inputRef, pickerOpen } = this.state;
    return (
      <div>
        <input
          ref={this.onRef}
          className="form-control"
          onFocus={this.onFocus}
          onMouseDown={this.onMouseDown}
          value={lines ? lines.join(",") : ""}
          placeholder="Line IDs"
        />
        {inputRef ? (
          <LinePickerContainer
            autoFocus={true}
            target={inputRef}
            checked={lines}
            onSelect={this.onSelect}
            isOpen={pickerOpen}
          />
        ) : null}
      </div>
    );
  }

  private onMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    if (this.state.pickerOpen) {
      e.preventDefault();
      this.setState({ pickerOpen: false });
    }
  };

  private onFocus = () => {
    this.setState({ pickerOpen: true });
  };

  private onSelect = (id: LineID) => {
    const { lines, onChange } = this.props;

    const lineSet = new Set(lines);

    if (lineSet.has(id)) {
      lineSet.delete(id);
    } else {
      lineSet.add(id);
    }

    onChange(Array.from(lineSet));

    this.setState({
      pickerOpen: false,
    });
  };

  private onRef = (inputRef: HTMLInputElement | null) => {
    this.setState({ inputRef });
  };
}



// WEBPACK FOOTER //
// ./src/components/LineIDInput.tsx